import PropTypes from 'prop-types'
import React from 'react'

// Id linking an input to its error text; derived in one place so the
// aria-describedby / span-id pair can never drift apart.
export const errorId = (id) => `${id}-error`

// Spread onto the input owning the error: exposes the invalid state to
// assistive tech and points aria-describedby at the InlineError span.
export const ariaErrorProps = (id, invalid) => ({
  'aria-invalid': invalid ? true : undefined,
  'aria-describedby': id ? errorId(id) : undefined
})

// The standard error line under a form field. Always rendered — hidden while
// there is no message — so the input's aria-describedby reference stays valid.
function InlineError({ id, message }) {
  return (
    <span
      id={id ? errorId(id) : undefined}
      className={`field__error${!message ? ' field__error--hidden' : ''}`}
      role="alert"
    >
      {message}
    </span>
  )
}

InlineError.propTypes = {
  id: PropTypes.string,
  message: PropTypes.node
}

export default InlineError
